import { ExcerptPipe } from './core/pipes/excerpt.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationModule } from './navigation/navigation.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { environment } from 'src/environments/environment';
import { IndustriepartnerService } from './core/services/interfaces/industriepartner.service';
import { AngebotsListenService } from './core/services/interfaces/angebots-listen.service';
import { ApothekenService } from './core/services/interfaces/apotheken.service';
import { InjectionToken } from '@angular/core';
import {
    SERVICE_URL,
    SHOWCASE_URL,
    REPORTING_PATH,
} from '../environments/tokens';
import { BasicAuthInterceptor } from './core/interceptors/basic-auth.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { ReportingService } from './core/services/interfaces/reporting.service';
import { LoggedInGuard } from './core/guards/logged-in.guard';
import { AuthService } from './core/services/auth.service';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { IndustriepartnerComponent } from './industriepartner/industriepartner.component';
import {FlexModule} from '@angular/flex-layout';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {IndustriepartnerHttpService} from './core/services/industriepartner-http.service';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import { IndustriepartnerDetailsComponent } from './industriepartner-details/industriepartner-details.component';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfilComponent } from './profil/profil.component';
import { DeleteDeactivateModalComponent } from './modals/delete-deactivate-modal/delete-deactivate-modal.component';
import { AdminComponent } from './admin/admin.component';
import { BerechnungComponent } from './berechnung/berechnung.component';
import {NumericTextBoxModule} from '@syncfusion/ej2-angular-inputs';
import {menu, NgxEditorModule, placeholder} from 'ngx-editor';
import { IndustriepartnerNeuComponent } from './industriepartner-neu/industriepartner-neu.component';
import { DisplayIndexComponent } from './displays/display-index/display-index.component';
import { DisplayCreateComponent } from './displays/display-create/display-create.component';
import { DisplayEditComponent } from './displays/display-edit/display-edit.component';
import { AskDeleteComponent } from './modals/ask-delete/ask-delete.component';
import { AngebotsListenHttpService } from './core/services/angebots-listen-http.service';
import { MailjetIndexComponent } from './mailjet/mailjet-index/mailjet-index.component';
import { ActivitychartComponent } from './activitychart/activitychart.component';
import { OrderchartComponent } from './orderchart/orderchart.component';

registerLocaleData(localeDe);

@NgModule({
    declarations: [AppComponent, PasswordResetComponent, IndustriepartnerComponent, IndustriepartnerDetailsComponent, DashboardComponent, ProfilComponent, DeleteDeactivateModalComponent, AdminComponent, BerechnungComponent, IndustriepartnerNeuComponent, DisplayIndexComponent, DisplayCreateComponent, DisplayEditComponent, ExcerptPipe, AskDeleteComponent, MailjetIndexComponent, ActivitychartComponent, OrderchartComponent],
    imports: [
        CoreModule,
        AppRoutingModule,
        HttpClientModule,
        NavigationModule,
        BrowserAnimationsModule,
        MatDialogModule,
        MatCardModule,
        MatButtonModule,
        MatRadioModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        FlexModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatSortModule,
        ReactiveFormsModule,
        MatListModule,
        MatIconModule,
        NumericTextBoxModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatCheckboxModule,

    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'de' },
        {
            provide: IndustriepartnerService,
            useClass: environment.industriepartnerService,
        },
      {
          provide: IndustriepartnerHttpService,
          useClass: environment.industriepartnerService
      },
        {
            provide: AngebotsListenService,
            useClass: environment.angebotslistenService,
        },
        {
            provide: AngebotsListenHttpService,
            useClass: AngebotsListenHttpService,
        },
        {
            provide: ApothekenService,
            useClass: environment.apothekenService,
        },
        {
            provide: ReportingService,
            useClass: environment.reportingService,
        },
        {
            provide: SERVICE_URL,
            useValue: environment.angebotServiceUrl,
        },
        {
            provide: SHOWCASE_URL,
            useValue: environment.showcaseUrl,
        },
        {
            provide: REPORTING_PATH,
            useValue: environment.reportingPath,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BasicAuthInterceptor,
            multi: true,
        },
        {
            provide: AuthService,
            useClass: AuthService,
        },
        {
            provide: LoggedInGuard,
            useClass: LoggedInGuard,
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: { duration: 3000, panelClass: ['primary-snackbar'] },
        },
    ],
    entryComponents: [PasswordResetComponent, DeleteDeactivateModalComponent],
    bootstrap: [AppComponent],
})
export class AppModule {}
